import * as React from "react";
import styled from "styled-components";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    text-align: center;
  }
`;
const Headline = styled.h2`
  margin-top: 5px;
  margin-bottom: 10px;
  text-align: center;
`;
const EmptyEntity = ({ children, title = "Looks like there is nothing here, yet!" }) => /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Headline, null, title), children);
export default EmptyEntity;
